export {
  TextParagraph as default,
  TextParagraph,
  TextParagraphBodyLarge,
  TextParagraphBodyMedium,
  TextParagraphBodySmall,
  TextParagraphLabel,
  TextParagraphTag,
  TextParagraphInlineText,
  TextParagraphBlockText,
  type TextParagraphProps,
  type TextElement,
  type ParagraphVariant,
  type ParagraphColor,
  type ParagraphWeight,
  type ParagraphAlign,
} from './TextParagraph';
